import React from 'react'
import { Box } from '@material-ui/core'

export const Spacing = props => {
  // Using div and padding due to library bug affecting MUI Box component, revert back when fixed
  // return <div {...props} style={{ padding: 8 }} />
  return <Box {...props} />
}
